const typography = {
  useNextVariants: true,
  fontFamily: [
    // 'Sen',
    // 'Montserrat',
    // 'Poppins',
    // 'Source Sans Pro',
    // 'Roboto',
    // 'Open Sans',
    'Noto Sans',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Verdana',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  h1: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h6: {
    fontSize: '1.0625rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  body1: {
    fontSize: '0.875rem',
    lineHeight: 1.75,
    letterSpacing: -0.15,
    // fontFamily: "Open Sans"
    // wordSpacing: 4,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.75,
    letterSpacing: -0.15,
    // fontFamily: "Open Sans"
  },
  button: {
    textTransform: 'none',
    letterSpacing: 1,
  },
};

export default typography;
